const API_ROUTES = Object.freeze({
  SETTINGS: "/api/settings/",
  LOCATION_SETTINGS: "/api/settings/locations/",
});

const QUERY_KEYS = Object.freeze({
  SETTINGS: "settings",
});

export { API_ROUTES, QUERY_KEYS };
